import {Modal} from "flowbite";

window.createModal = function createModal(modalElementId, onShowCallback, onHideCallback) {
    const modalEl = document.getElementById(modalElementId);

    if (typeof FlowbiteInstances !== 'undefined') {
        const dropdownInstances = FlowbiteInstances.getInstances('Dropdown');
        if (dropdownInstances) {
            Object.keys(dropdownInstances).forEach(key => {
                dropdownInstances[key].hide();
            });
        }
    }

    if (!modalEl) throw new Error(`Modal element with id ${modalElementId} not found`);
    if (onShowCallback && typeof onShowCallback !== "function") throw new Error('onShowCallback parameter must be a function');
    if (onHideCallback && typeof onHideCallback !== "function") throw new Error('onHideCallback parameter must be a function');

    const backdrop = modalEl.dataset.modalBackdrop || 'dynamic';
    const closable = modalEl.dataset.closable ? modalEl.dataset.closable === 'true' : true;

    const options = {
        backdrop,
        backdropClasses: 'modal-backdrop',
        closable,
        onHide: () => {
            if (!modalEl.dataset.noDestroy) {
                modalEl.remove();
            }
            onHideCallback && onHideCallback();
        },
        onShow: () => {
            typeof initSelect2Plugin === 'function' && initSelect2Plugin(modalEl);

            if (typeof window.initDropzone === 'function') {
                window.initDropzone(modalEl);
            }

            if (typeof window.initSummernote === 'function') {
                window.initSummernote(modalEl);
            }

            document.querySelectorAll(`[data-modal-hide="${modalEl.id}"]`).forEach(item => {
                item.addEventListener('click', () => { closeModal(modalElementId); });
            });

            onShowCallback && onShowCallback();
        }
    };

    const instanceOptions = {
        id: modalEl.id,
        override: true
    };

    return new Modal(modalEl, options, instanceOptions);
};

window.showModal = function showModal(modalElementId, onShowCallback, onHideCallback) {
    const modal = createModal(modalElementId, onShowCallback, onHideCallback);
    modal.show();
}

window.closeModal = function closeModal(modalElementId) {
    const modal = FlowbiteInstances.getInstances('Modal')[modalElementId];

    if (modal) {
        modal.hide();

    } else {
        console.warn(`Modal with id ${modalElementId} not found.`);
    }
}

window.getHtmlToModal = function getHtmlToModal(url, dialogId, onShowCallback, onHideCallback) {
    if (!url || !dialogId) {
        throw new Error('Parâmetros inválidos. Necessário informar os parâmetros "url" e "dialogId"!');
    }

    // Faz a requisição para obter o HTML do modal
    axios.get(url)
        .then(response => {
            const data = response.data;

            if (!data.success) {
                throw new Error(data.message);
            }

            if (!data.html || !data.html.length) {
                throw new Error('Está faltando o HTML de retorno.');
            }

            const openModal = document.getElementById(dialogId);

            if (openModal) {
                openModal.remove();
            }

            $('body').append(data.html);
            showModal(dialogId, onShowCallback, onHideCallback);

        })
        .catch(error => {
            console.error(error);
            Spinner.hide();
            showNotification(error.response?.data?.message ?? error.message ?? error ?? 'Não foi possível concluir a operação. Por favor, tente novamente!', { type: 'error' });
        });
}

$(document).on('click', '[data-action=open-modal]', event => {
    const dialogId = event.currentTarget.dataset.dialogId;

    if (!dialogId) throw new Error(`É necessário informar o atributo "data-dialog-id" no elemento ${event.currentTarget.outerHTML}!`);

    window.showModal(dialogId);
});

/**
 * Controla o click sobre os botões de edição dos registros
 * O evento precisa ser adicionado no document, para funcionar dentro da paginação do dataTables
 */
$(document).on('click', '[data-action=open-dialog]', event => {
    const el = event.currentTarget;

    const url = el.dataset.url;
    const dialogId = el.dataset.dialogId;

    if (!dialogId || !url) throw new Error(`É necessário informar os atributos "data-dialog-id" e "data-url" no elemento ${el.outerHTML}!`);

    getHtmlToModal(url, dialogId);
});
